import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import packageJson from '../../../package.json';

const { Footer } = Layout;

const FootersLayout = () => {
    const currentYear = new Date().getFullYear();
    return (
        <Footer style={{ textAlign: 'center' }} className="space-x-2">
            <span>
                Copyright ©2022 - {currentYear} Whitefact v.
                {packageJson.version}
            </span>
            <span>|</span>
            <a
                target="_blank"
                href="https://whitefact.co/privacy-policy/"
                rel="noreferrer"
            >
                Privacy Policy
            </a>
            <span>|</span>
            <span>Terms And Conditions</span>
            <span>|</span>
            <Link target="_blank" rel="noreferrer" to="/open-source">
                Open Source
            </Link>
        </Footer>
    );
};

export default FootersLayout;
